<template>
  <div id="mood-container" :class="{ opened: numSelezionati > 0 }">
    <div id="mood-header" v-if="!loading && numSelezionati == 0">
      <h3 v-if="lang == 'en'" class="title">Create your moodboard</h3>
      <h3 v-else class="title">Crea il tuo moodboard</h3>
      <p v-if="lang == 'en'" class="instruction">Select 4 images</p>
      <p v-else class="instruction">Seleziona 4 immagini</p>
    </div>

    <div id="mood-header" v-if="numSelezionati > 0 && numSelezionati < 4">
      <h3 v-if="lang == 'en'" class="title">Create your moodboard</h3>
      <h3 v-else class="title">Crea il tuo moodboard</h3>
      <p v-if="lang == 'en'" class="instruction">
        You have selected {{ numSelezionati }} of 4 images
      </p>
      <p v-else class="instruction">
        Hai selezionato {{ numSelezionati }} di 4 immagini
      </p>
    </div>

    <div id="mood-header" v-if="!loading && numSelezionati == 4">
      <h3 v-if="lang == 'en'" class="title">Create your moodboard</h3>
      <h3 v-else class="title">Crea il tuo moodboard</h3>
      <p v-if="lang == 'en'" class="instruction">
        Are you curious about what you will get?
      </p>
      <p v-else class="instruction">Sei curioso di sapere cosa ti arriverà?</p>
    </div>

    <div id="mood-selected" :class="`selezionate ${numSelezionati == 4}`">
      <div v-for="sel in selected" :key="sel.id" class="img">
        <img :src="sel.url" />
        <button @click="deseleziona(sel)" class="delete">x</button>
      </div>
    </div>

    <div v-if="sizeSelector" class="sizes">
      <h3 v-if="lang == 'en'" class="title">Your size</h3>
      <h3 v-else class="title">La tua taglia</h3>
      <p v-if="lang == 'en'" class="instruction">
        Discover the star garments available
      </p>
      <p v-else class="instruction">Scopri i capi star disponibili</p>
      <button @click="selectSize('S')" class="size">S</button>
      <button @click="selectSize('M')" class="size">M</button>
      <button @click="selectSize('L')" class="size">L</button>
    </div>

    <div v-if="!loading">
      <div v-if="images && numSelezionati < 4" class="mood">
        <label
          class="image"
          v-for="image in images"
          :key="image.id"
          data-aos="zoom-in"
        >
          <input
            type="checkbox"
            :value="image"
            @change="selectImage($event, image)"
            :checked="selected.some((data) => data.id === image.id)"
            :disabled="numSelezionati >= 4"
          />
          <img :src="image.url" />
        </label>
      </div>
      <div class="mood-buttons">
        <button
          @click.prevent="reset()"
          class="btn btn-dark-outline"
          v-if="numSelezionati < 4"
        >
          <span v-if="lang == 'en'">
            Delete
          </span>
          <span v-else>
            Annulla
          </span>
        </button>
        <button
          @click.prevent="fetchImages()"
          v-if="numSelezionati < 4"
          class="btn btn-white"
        >
          <span v-if="lang == 'en'">
            Load more
          </span>
          <span v-else>
            Carica altre
          </span>
        </button>
      </div>
    </div>
    <div v-else class="loading">
      <Preloader />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Preloader from "@/components/Preloader.vue";

export default {
  data() {
    return {
      sizeSelector: false,
      images: [],
      loading: true,
      numSelezionati: 0,
      selected: [],
      keywords: [],
    };
  },

  components: {
    Preloader,
  },

  props: {
    lang: String,
  },

  computed: {},

  watch: {
    selected: function(val) {
      this.sizeSelector = val.length == 4 ? true : false;
      this.numSelezionati = val.length;
    },
  },
  methods: {
    fetchImages() {
      this.loading = true;
      axios
        .get(window["wpApiSettings"].root + "menaboh/v1/images")
        .then(
          (response) => ((this.images = response.data), (this.loading = false))
        );
    },

    selectImage(evt, image) {
      if (evt.target.checked) {
        this.selected.push(image);
        this.keywords.push(image.keywords);
      } else {
        this.selected.splice(this.selected.indexOf(image), 1);
        this.keywords.splice(this.keywords.indexOf(image.keywords), 1);
      }
      localStorage.setItem("menaboh_selected", JSON.stringify(this.selected));
      localStorage.setItem("menaboh_keywords", JSON.stringify(this.keywords));
    },

    selectSize(value) {
      localStorage.setItem("menaboh_size", value);
      this.$store.commit("goToStep", 3);
    },

    deseleziona(sel) {
      this.selected.splice(this.selected.indexOf(sel), 1);
      this.keywords.splice(this.keywords.indexOf(sel.keywords), 1);
      localStorage.setItem("menaboh_selected", JSON.stringify(this.selected));
      localStorage.setItem("menaboh_keywords", JSON.stringify(this.keywords));
    },

    reset() {
      this.$store.commit("goToStep", 1);
    },
  },

  mounted() {
    this.fetchImages();
  },
};
</script>

<style scoped lang="scss">

.loading {
  height: 100%;
  display: flex;
  align-items: center;
}

#mood-container {
  padding: 70px 1rem 1rem 1rem;
  transition: all 0.4s ease-in-out;
  overflow-y: auto;
  min-height: 100%;
}

#mood-header {
  text-align: center;
}

.instruction {
  margin: 0 0 1rem 0;
}
.mood {
  display: flex;
  flex-wrap: wrap;
  margin: 1rem auto;
  max-width: 960px;
  justify-content: center;
}

.mood .image {
  cursor: pointer;
  width: 33.333%;
  padding: 8px;
  @media screen and (min-width: 768px) {
    width: 25%;
    padding: 14px;
  }
  input {
    display: none;
  }
}

.mood .image img {
  max-width: 100%;
  transition: all 0.3s ease-in-out;
}
.mood .image:hover {
  transform: scale(1.04);
}

.selezionate {
  display: flex;
  justify-content: center;
  padding: 1rem;

  &.true {
    top: 0;
  }

  .img {
    max-width: 120px;
    position: relative;
    margin: 5px;
    img {
      width: 100%;
      height: auto;
      border-radius: 50%;
    }
    .delete {
      position: absolute;
      top: 7%;
      right: 7%;
      z-index: 2;
      background: black;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      color: white;
      text-align: center;
      line-height: 18px;
      cursor: pointer;
      font-size: 9px;
      font-weight: bold;

      &:hover {
        transform: scale(1.04);
      }
    }
  }

  &.true {
    flex-wrap: wrap;
    .img {
      width: 50%;
    }
  }
}

.sizes {
  display: block;
  text-align: center;
  padding: 1rem;
  margin-top: 2rem;

  .size {
    display: inline-block;
    font-size: 2rem;
    margin: 0 0.5rem;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    text-align: center;
    line-height: 50px;
    border: 2px solid black;
    padding: 0;

    &:focus {
      background: black;
      color: white;
    }
  }
}
</style>
